import { RootState } from '../../store/store'

export const selectAllVideos = (state: RootState) => state.video.videos
export const selectCurrentVideo = (state: RootState) => state.video.currentVideo
export const selectCurrentVideoIndex = (state: RootState) =>
  state.video.currentIndex
export const selectIsVideoLoading = (state: RootState) => state.video.isLoading
export const selectIsPlayingVideo = (state: RootState) => state.video.isPlaying
export const selectErrorVideo = (state: RootState) => state.video.error
export const selectVideoProgressById = (id: string) => (state: RootState) => {
  const video = state.video.videos.find((video) => video.id === id)
  return video?.progress || 0
}
export const selectFullScreenVideo = (state: RootState) =>
  state.video.fullScreen
